/* eslint-disable max-nested-callbacks */
import { e, getScrollTop } from './helpers';
import 'slick-carousel';

/**
 *
 */
function navbarFixed() {
  const $navbar = $('.header');
  const $preHeader = $('.pre-header');

  if ($navbar.length) {
    if (getScrollTop() > $preHeader.height()) {
      $navbar.addClass('fixed');
    } else {
      $navbar.removeClass('fixed');
    }
  }
}

$(window).on('load scroll resize', () => {
  navbarFixed();
});

$(document).on('click', '.dropdown-content .dropdown-menu', event => {
  event.stopPropagation();
});
const slider = document.getElementById('testimonials-slider');
$('.company').on('show.bs.dropdown', () => {
  if (slider.children.length === 0) {
    fetch('/company/testimonials/data.json')
      .then(res => res.json())
      .then(data => {
        const filteredData = data.filter(item => item.inSlider);
        // eslint-disable-next-line no-restricted-syntax
        for (const item of filteredData) {
          slider.append(e('div', {
            class: 'slide'
          }, [
            e('blockquote', {
              class: 'blockquote clearfix'
            }, [
              e('p', {}, item.message),
              e('cite', {}, [
                e('b', {}, item.name),
                e('br'),
                e('span', {}, item.position)
              ])
            ])
          ]));
        }
      })
      .then(() => {
        $('#testimonials-slider').slick({
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 350,
          draggable: true,
          swipe: true,
          dots: true,
          fade: true,
          arrows: false,
          cssEase: 'linear',
          pauseOnHover: true,
          infinite: true
        });
        $('#testimonials-slider').slick('resize');
        $('#testimonials-slider').css({
          opacity: 1
        });
      });
  }
});
$('.company').on('hide.bs.dropdown', () => {
  $('.company .slick-initialized').slick('unslick');
  slider.innerHTML = '';
});

const searchForm = document.getElementById('searchForm');

if (searchForm) {
  searchForm.addEventListener('submit', event => {
    event.preventDefault();
    const q = event.target.searchQuery.value;
    window.location.href = `/search/?q=${q}`;
  });
}
